import { useTranslation } from "react-i18next";
import { enUS, pl } from "date-fns/locale";

export default function useLocaleByLanguage() {
  const { i18n } = useTranslation();

  if (i18n.language === "GB") {
    return enUS;
  } else {
    return pl;
  }
}
